export default {"src":"/_next/static/media/error404.5f0155b9.svg","height":162,"width":456};